module.exports = __webpack_public_path__ + "media/components/assets/img/icons/loader-19fd34839b72854ca875ac340fca7824.svg";